var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.c_value))]),_vm._v(" "),(_vm.c_ctrlParams.extraDescr)?_c('div',{staticClass:"ctrl-extraDescr",domProps:{"innerHTML":_vm._s(_vm.c_ctrlParams.extraDescr)}}):_vm._e()])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }